var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25C13.5563 17.25 17.25 13.5563 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75ZM6.08175 6.40951C6 6.56994 6 6.77996 6 7.2V10.8C6 11.22 6 11.4301 6.08175 11.5905C6.15365 11.7316 6.26839 11.8463 6.40951 11.9183C6.56994 12 6.77996 12 7.2 12H10.8C11.22 12 11.4301 12 11.5905 11.9183C11.7316 11.8463 11.8463 11.7316 11.9183 11.5905C12 11.4301 12 11.22 12 10.8V7.2C12 6.77996 12 6.56994 11.9183 6.40951C11.8463 6.26839 11.7316 6.15365 11.5905 6.08175C11.4301 6 11.22 6 10.8 6H7.2C6.77996 6 6.56994 6 6.40951 6.08175C6.26839 6.15365 6.15365 6.26839 6.08175 6.40951Z",
    fill: "#141922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCircle);
export default __webpack_public_path__ + "static/media/stop-circle.e1e965d0dce6e57b70031e6a32776d51.svg";
export { ForwardRef as ReactComponent };